<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="panel">
        <div class="panel-hdr">
          <div class="w-100">
            <div class="row">
              <div class="col-lg-6 col-sm-12">
                <h1 class="subheader-title mb-2 mb-lg-0">
                  <i class="subheader-icon fal fa-address-book"></i> Список контактов
                </h1>
              </div>
              <div class="col-lg-6 col-sm-12 text-lg-right text-sm-left" v-if="contacts.length > 0 || search">
                <button data-button="contact-create" class="btn btn-sm btn-outline-success mr-2" v-on:click="contactCreate">Добавить контакт</button>
                <div class="input-group input-group-sm d-inline-flex" v-bind:class="{ 'has-length': searchFocus }">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-transparent border-right-0">
                      <i class="fal fa-search"></i>
                    </span>
                  </div>
                  <input data-input="search" type="search" class="form-control border-left-0 bg-transparent pl-0" v-on:focus="searchFocus = true" v-on:blur="searchFocus = false" v-model="search" placeholder="Поиск"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-container show">
          <div class="panel-container show" v-if="loading">
            <div class="panel-content p-6 m-6">
              <content-placeholders :centered="true">
                <content-placeholders-text :lines="4" />
              </content-placeholders>
            </div>
          </div>
          <div class="panel-content" v-if="contacts.length === 0 && !loading">
            <div class="text-center m-auto" style="max-width: 25em">
              <i class="fal fa-comment fa-3x color-primary-300"></i>
              <br />
              <button data-button="contact-create" class="btn btn-outline-success mt-3" v-on:click="contactCreate">Добавить контакт</button>
              <div class="lead pt-3">Добавьте первый контакт для получения уведомлений по заданиям.</div>
            </div>
          </div>
          <div class="panel-content p-3" v-if="contacts.length > 0 && !loading">
            <div data-element="contacts" id="js_default_list">
              <paginate name="contacts" class="list-group" :list="contacts" :per="25">
                <li :data-id="contact.id" class="list-group-item" v-for="(contact, index) in paginated('contacts')" :key="contact.id">
                  <span class="d-flex align-items-center w-100 position-relative">
                    <div :data-name="contact.name" class="d-flex flex-row align-items-center mt-1 mb-1">
                      <span class="fs-xl text-truncate text-dark fw-500 contact-name">
                        {{ contact.name }}
                        <a :href="contact.link" class="d-block fs-sm fw-400 text-muted">{{ contact.value }}</a>
                      </span>
                    </div>
                    <div class="ml-auto">
                      <button data-button="edit" v-on:click="contactEdit(contact)" class="btn btn-outline-success btn-icon rounded-circle waves-effect waves-themed">
                        <i class="fal fa-pencil fs-md"></i>
                      </button>
                      <button data-button="verify" v-if="!contact.verify" v-on:click="contactVerify(contact)" class="btn btn-outline-info btn-icon rounded-circle waves-effect ml-2 waves-themed">
                        <i class="fal fa-key fs-md"></i>
                      </button>
                      <button data-button="remove" v-on:click="contactRemove(contact, index)" class="btn btn-outline-secondary btn-icon rounded-circle ml-2 waves-effect waves-themed">
                        <i class="fal fa-trash fs-md"></i>
                      </button>
                    </div>
                  </span>
                </li>
              </paginate>
            </div>
            <nav>
              <paginate-links
                for="contacts"
                :hide-single-page="true"
                :show-step-links="true"
                :limit="25"
                :classes="{
                  'ul': ['pagination', 'justify-content-center', 'pt-4', 'pb-0', 'mb-0'],
                  'ul > li': 'page-item',
                  'ul > li > a': 'page-link',
                }"
              ></paginate-links>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <ContactsEdit v-bind:contact="editContact" v-if="editStatus" v-on:close="contactEditClose"/>
    <ContactsVerify v-bind:contact="verifyContact" v-if="verifyStatus" v-on:close="contactVerifyClose"/>
    <ContactsCreate v-if="createStatus" v-on:close="contactCreateClose"/>
  </div>
</template>

<script>
import ComponentContactsCreate from "@/components/contacts/create.vue";
import ComponentContactsEdit from "@/components/contacts/edit.vue";
import ComponentContactsVerify from "@/components/contacts/verify.vue";
import Vue2Filters from 'vue2-filters';

export default {
  metaInfo: {
    title: "Список контактов"
  },
  data() {
    return {
      // Статус загрузки
      loading: true,
      // Строка поиска
      search: '',
      searchFocus: false,
      // Контакты
      data: [],
      // Постраничная навигация
      paginate: ['contacts'],
      // Изменение
      editStatus: false,
      editContact: {},
      // Создание
      createStatus: false,
      // Верификация
      verifyStatus: false,
      verifyContact: {},
    };
  },
  components: {
    ContactsEdit: ComponentContactsEdit,
    ContactsCreate: ComponentContactsCreate,
    ContactsVerify: ComponentContactsVerify
  },
  mixins: [Vue2Filters.mixin],
  computed: {
    contacts() {
      return this.filterBy(this.data, this.search, 'name', 'value')
    }
  },
  methods: {
    // Подтверждение контакта
    contactVerify (contact) {
      this.verifyContact = {...contact};
      this.verifyStatus = true;
    },
    // Завершение подтверждения
    contactVerifyClose (contactsReload = false)
    {
      this.verifyStatus = false;
      this.verifyContact = {};

      // Обновление списка задач при сохранении
      if(contactsReload)
        this.contactsListUpdate();
    },
    // Редактирование контакта
    contactEdit (contact) {
      this.editContact = {...contact};
      this.editStatus = true;
    },
    // Завершение редактирования
    contactEditClose (contactsReload = false)
    {
      this.editStatus = false;
      this.editContact = {};

      // Обновление списка задач при сохранении
      if(contactsReload)
        this.contactsListUpdate();
    },
    contactCreate () {
      this.createStatus = true;
    },
    // Завершение создания
    contactCreateClose (contactsReload = false, openVerify = false, contact = {})
    {
      this.createStatus = false;

      // Обновление списка задач при сохранении
      if(contactsReload)
        this.contactsListUpdate();

      // Открытие окна с подтверждением контакта
      if(openVerify)
        this.contactVerify(contact);
    },
    // Обновление списка задач
    contactsListUpdate (indicator = true) 
    {
      // Индикатор загрузки
      if(indicator)
        this.loading = true;

      this.$axios.get(process.env.VUE_APP_API_URL+'/v1/contacts').then(response =>
      {
        this.data = response.data.data;
        this.loading = false;
      });
    },
    // Удаление контакта
    contactRemove (contact, index) 
    {
      if(confirm('Вы действительно хотите удалить контакт "'+contact.name+'"?'))
      {
        this.$axios.get(process.env.VUE_APP_API_URL+'/v1/contacts/'+contact.id+'/remove');
        this.$delete(this.data, index);
      }
    }
  },
  // Подгрузка данных
  mounted () 
  {
    this.contactsListUpdate();
  },
};
</script>